import {ReactComponent as EmailIcon} from './email.svg'

function Email() {
  return <EmailIcon />
}

export default Email
